module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/uv-index-90f496ccc9b831620b55479af21310d8.svg";